import { Money } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  children?: React.ReactNode;
};

const SuggestionBudgetSpan = ({ children }: Props) => {
  return (
    <div
      className={cn(
        'flex h-5 flex-row items-center justify-center gap-0.5 px-1 py-0.5',
        typographyVariants({ variant: 'caption1', color: 'secondary' }),
      )}
    >
      <Money className="size-4 fill-icon-secondary" />
      {children}
    </div>
  );
};

export default SuggestionBudgetSpan;
